export const base_image = (folder, name) => {
    return "https://admin.boaordmc.com/static/" + folder + "/" + name;
  };